var React = require('react');

function IncorrectInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"34","height":"34","rx":"5","stroke":"#FD2387","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M22.9497 11.364C23.3403 10.9734 23.9734 10.9734 24.364 11.364C24.7545 11.7545 24.7545 12.3877 24.364 12.7782L13.0503 24.0919C12.6597 24.4824 12.0266 24.4824 11.636 24.0919C11.2455 23.7014 11.2455 23.0682 11.636 22.6777L22.9497 11.364Z","fill":"#FD2387","key":1}),React.createElement("path",{"d":"M24.364 22.6777C24.7545 23.0682 24.7545 23.7014 24.364 24.0919C23.9734 24.4824 23.3403 24.4824 22.9497 24.0919L11.636 12.7782C11.2455 12.3876 11.2455 11.7545 11.636 11.364C12.0266 10.9734 12.6597 10.9734 13.0503 11.364L24.364 22.6777Z","fill":"#FD2387","key":2})]);
}

IncorrectInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IncorrectInline;

IncorrectInline.default = IncorrectInline;
